import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'formatModuleName' })
export class FormatModuleNamePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return ''

    // Insert space before each uppercase letter (except the first char)
    const withSpaces = value.replace(/([A-Z])/g, ' $1')

    // Capitalize the first letter of each word (title case)
    return withSpaces.replace(/\b\w/g, char => char.toUpperCase()).trim()
  }
}
